import { createSlice } from '@reduxjs/toolkit';

interface GroupSlice {
  group: {
    id: string;
    createdAt?: string;
    name?: string;
    numberOfContacts?: number;
  };
  groupsId: Array<object>;
}

const initialState: GroupSlice = {
  group: {
    id: '',
    createdAt: '',
    name: '',
    numberOfContacts: 0,
  },
  groupsId: [],
};

export const groupSlice = createSlice({
  name: 'group',
  initialState,
  reducers: {
    selectGroup: (state, { payload }) => {
      state.group = { ...payload, header: {} };
    },
    resetGroup: (state) => {
      state.group = initialState.group;
    },
    setGroup: (state, action) => {
      state.group = action.payload;
    },
    removeGroups: (state) => {
      state.groupsId = [];
    },
  },
});

export const { setGroup, removeGroups, resetGroup, selectGroup } =
  groupSlice.actions;

export default groupSlice.reducer;
